module.exports = __webpack_public_path__ + "img/partner-new-icon6.1ca61155.svg";